import React from 'react';
import { Spinner } from 'react-bootstrap';
import { ButtonLink } from '../ButtonLink/ButtonLink';

export const LoadingButton = ({
  loading = false,
  loadingText = 'Saving...',
  children,
  showSpinner = true,
  variant = 'primary',
  disabled,
  onClick,
  as: Component = ButtonLink,
  ...rest
}) => {
  const isDisabled = disabled ?? loading;

  return (
    <Component
      variant={variant}
      onClick={onClick}
      disabled={isDisabled}
      {...rest}
    >
      {loading && showSpinner && (
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          className="me-2"
        />
      )}
      {loading ? loadingText : children}
    </Component>
  );
};
